import { Component } from '@angular/core';
import { SalesDashboardComponent } from '../sales-dashboard/sales-dashboard.component';
import { AdminDashboardComponent } from '../admin-dashboard/admin-dashboard.component';

@Component({
  selector: 'app-outbound-leads',
  standalone: true,
  imports: [
    SalesDashboardComponent,
    AdminDashboardComponent
  ],
  templateUrl: './outbound-leads.component.html',
  styleUrls: ['../styles/leads.css', './outbound-leads.component.css']
})
export class OutboundLeadsComponent {

  loggedInUser: any;
  userDepartment: any;
  loggedInUserName: any;
  assistantUser: any;

  ngOnInit() {
    this.userDepartment = localStorage.getItem("department");
    this.loggedInUser = this.userDepartment === "ADMIN" || this.userDepartment === "MARKETING";
    this.assistantUser = this.userDepartment === "ASSISTANT-SALES";
    this.loggedInUserName = localStorage.getItem("username");
  }

}
